import { render, staticRenderFns } from "./AddEmployeeForm.vue?vue&type=template&id=c2b74f18"
import script from "./AddEmployeeForm.vue?vue&type=script&lang=ts"
export * from "./AddEmployeeForm.vue?vue&type=script&lang=ts"
import style0 from "./AddEmployeeForm.vue?vue&type=style&index=0&id=c2b74f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports